import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Send, MailOpen, CheckCheck, XCircle, Plus } from "lucide-react";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { api, fmtDate } from "@/lib/api";
import { Card, Kpi, StatusBadge } from "./shared";

export default function CampaignOverview() {
  const [a, setA] = useState(null);
  const [camps, setCamps] = useState([]);
  useEffect(() => {
    api.get("/admin/campaigns/analytics/summary").then((r) => setA(r.data));
    api.get("/admin/campaigns/").then((r) => setCamps(r.data.slice(0, 6)));
  }, []);
  if (!a) return <p className="font-mono text-sm text-slate-500">Memuat...</p>;
  return (
    <div className="space-y-6" data-testid="campaign-overview">
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <Kpi icon={Send} label="Total Terkirim" value={a.total_sent} testid="kpi-total-sent" />
        <Kpi icon={MailOpen} label="Email Open Rate" value={`${a.email_open_rate}%`} tone="text-sky-700" testid="kpi-email-open-rate" />
        <Kpi icon={CheckCheck} label="WhatsApp Read Rate" value={`${a.wa_read_rate}%`} tone="text-emerald-700" testid="kpi-wa-read-rate" />
        <Kpi icon={XCircle} label="Gagal" value={a.failed} tone="text-rose-600" testid="kpi-failed" />
      </div>
      <div className="grid gap-6 lg:grid-cols-3">
        <Card title="Pengiriman 14 Hari Terakhir" className="lg:col-span-2">
          <div className="h-64"><ResponsiveContainer><BarChart data={a.daily}><CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" /><XAxis dataKey="date" fontSize={11} /><YAxis allowDecimals={false} fontSize={11} /><Tooltip /><Legend />
            <Bar dataKey="email" name="Email" fill="#0284C7" radius={[4, 4, 0, 0]} /><Bar dataKey="whatsapp" name="WhatsApp" fill="#10B981" radius={[4, 4, 0, 0]} /></BarChart></ResponsiveContainer></div>
        </Card>
        <Card title="Ringkasan">
          <dl className="space-y-4 text-sm">
            {[["Email terkirim", a.email_sent], ["WhatsApp terkirim", a.wa_sent], ["Terjadwal", a.scheduled], ["Dikirim ulang", a.resent], ["Campaign", a.campaigns], ["Template", a.templates]].map(([k, v]) => (
              <div key={k} className="flex justify-between"><dt className="text-slate-500">{k}</dt><dd className="font-bold text-[#0F2B48]">{v}</dd></div>
            ))}
          </dl>
          <Link to="/admin/campaign/campaigns/new" className="mt-6 flex items-center justify-center gap-2 rounded-lg bg-[#D97706] py-2.5 text-sm font-bold text-white hover:bg-[#B45309]" data-testid="overview-new-blast"><Plus size={16} /> New Blast</Link>
        </Card>
      </div>
      <Card title="Campaign Terbaru">
        <div className="divide-y">
          {camps.map((c) => (
            <div key={c.id} className="flex flex-wrap items-center justify-between gap-2 py-3 text-sm">
              <div><p className="font-semibold text-[#0F2B48]">{c.name}</p><p className="text-xs text-slate-500">{fmtDate(c.created_at)} · {(c.channels || []).join(" + ") || "belum diluncurkan"}</p></div>
              <StatusBadge status={c.status} />
            </div>
          ))}
          {!camps.length && <p className="text-sm text-slate-500">Belum ada campaign.</p>}
        </div>
      </Card>
    </div>
  );
}
